import { CountryCode } from 'interfaces/Country'
import ApiService from './ApiService'
import {
    CustomerInformation,
    UserSubscriptionStripeCardSetupResponse,
    StripeSubscription,
    StripeSubscriptionProductResponse,
    UserSubscriptionPaypalSetupResponse,
} from 'interfaces/StripeSubscription'
import { Language } from 'interfaces/Language'

const StripeSubscriptionService = {
    /**
     * @deprecated use pro plan billing plans
     */
    listProducts() {
        return ApiService.get(`/stripe-subscriptions/products/pro-plan`).then((response) => {
            return response.data.content as StripeSubscriptionProductResponse[]
        })
    },

    listProPlanProducts(countryCode: CountryCode) {
        return ApiService.get(`/stripe-subscriptions/products/pro-plan?countryCode=${countryCode}`).then((response) => {
            return response.data.content as StripeSubscriptionProductResponse[]
        })
    },

    createSubscriptionAndCustomer(customerInformation: CustomerInformation, interfaceLanguageCode: Language) {
        return ApiService.post(`/stripe-subscriptions`, { ...customerInformation, interfaceLanguageCode }).then(
            (response) => {
                return response.data as StripeSubscription
            }
        )
    },

    updateBillingAddress(subscriptionUuid: string, street: string, postalCode: string, city: string, country: CountryCode) {
        return ApiService.patch(`/stripe-subscriptions/${subscriptionUuid}/billing-address`, {
            street,
            postalCode,
            city,
            country,
        })
    },

    setupStripeCard(subscriptionUuid: string, priceId: string, countryCode: CountryCode) {
        return ApiService.post(`/stripe-subscriptions/${subscriptionUuid}/card/setup`, {
            priceId,
            countryCode,
        }).then((response) => {
            return response.data as UserSubscriptionStripeCardSetupResponse
        })
    },

    completeStripeCard(subscriptionUuid: string, paymentMethodId: string, priceId: string) {
        return ApiService.post(`/stripe-subscriptions/${subscriptionUuid}/card/complete`, {
            paymentMethodId,
            priceId,
            subscriptionId: subscriptionUuid,
        })
    },

    setupStripePaypal(subscriptionUuid: string) {
        return ApiService.post(`/stripe-subscriptions/${subscriptionUuid}/paypal/setup`).then((response) => {
            return response.data as UserSubscriptionPaypalSetupResponse
        })
    },

    completeStripePaypal(subscriptionUuid: string, priceId: string) {
        return ApiService.post(`/stripe-subscriptions/${subscriptionUuid}/paypal/complete`, {
            priceId,
            subscriptionId: subscriptionUuid,
        })
    },

    setupStripeSEPA(subscriptionUuid: string, priceId: string) {
        return ApiService.post(`/stripe-subscriptions/${subscriptionUuid}/sepa/setup`, {
            priceId,
        }).then((response) => {
            return response.data as UserSubscriptionStripeCardSetupResponse
        })
    },

    completeStripeSEPA(subscriptionUuid: string, paymentMethodId: string, priceId: string) {
        return ApiService.post(`/stripe-subscriptions/${subscriptionUuid}/sepa/complete`, {
            paymentMethodId,
            priceId,
            subscriptionId: subscriptionUuid,
        })
    },

    setupStripeSofort(subscriptionUuid: string, priceId: string) {
        return ApiService.post(`/stripe-subscriptions/${subscriptionUuid}/sofort/setup`, {
            priceId,
        }).then((response) => {
            return response.data as UserSubscriptionStripeCardSetupResponse
        })
    },

    completeStripeSofort(subscriptionUuid: string, priceId: string, countryCode: CountryCode) {
        return ApiService.post(`/stripe-subscriptions/${subscriptionUuid}/sofort/complete`, {
            priceId,
            countryCode,
        })
    },
}

export default StripeSubscriptionService
